import React from "react";
import ContactUs from "../components/ContactUs";
import Banner from "../components/Banner";
// import ContactDetails from "../components/ContactDetails";

function ContactUsPage() {
  return (
    <>
      {/* <ContactDetails /> */}
      <ContactUs />
      <Banner />
    </>
  );
}

export default ContactUsPage;
